<template>
  <i class="fa fa-fw" :class="logoClass"></i>
</template>

<script>
export default {
  props: {
    official: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logoClass() {
      return this.official ? 'fa-facebook-official' : 'fa-facebook';
    },
  },
  name: 'Facebook',
};
</script>

<style scoped>
.fa-facebook {
  color: #4767aa;
}
.fa-facebook-official {
  color: white;
}
</style>



// WEBPACK FOOTER //
// FacebookIcon.vue?a370a2bc